export const SERVICES = [
  { id: "hair-salon", name: "Hair Salon", desc: "Haircut • Creambath • Hair Spa • Smoothing • Keratin Treatment.", icon: "Scissors" },
  { id: "hair-coloring", name: "Hair Coloring", desc: "Basic • Ash/Highlight • Balayage • Peek a Boo.", icon: "Palette" },
  { id: "body-massage", name: "Body Massage", desc: "Full Body Massage • Reflexology Shoulder & Foot Scrub • Back Therapy • Miss V.", icon: "Sparkles" },
  { id: "nail-art", name: "Nail Art", desc: "Nail Art • Nail Courses • Gel Halal.", icon: "Gem" },
  { id: "kids-salon", name: "Kids Salon", desc: "Area potong rambut anak yang ceria dengan kursi khusus & bahan natural.", icon: "Smile" },
  { id: "hijab-room", name: "Hijab Room", desc: "Ruangan privat 100% tertutup khusus muslimah dengan terapis wanita.", icon: "ShieldCheck" },
  { id: "makeup", name: "Makeup", desc: "Makeup Wisuda • Hairdo • Party Makeup produk internasional.", icon: "Crown" },
  { id: "facial-beauty", name: "Facial & Beauty Treatment", desc: "Facial Care • Dermapeel • Acne • Melasma • Hair Removal.", icon: "Flower2" },
  { id: "shoe-wash", name: "Shoe Wash", desc: "Perawatan sepatu luxury & sneakers deep cleaning sambil Anda treatment.", icon: "Footprints" },
  { id: "klinik-kecantikan", name: "Klinik Kecantikan", desc: "Konsultasi dokter estetika bersertifikat, skin booster & rejuvenation.", icon: "Stethoscope" },
  { id: "salon-academy", name: "Salon Academy", desc: "Pendidikan sertifikasi profesional dari nol hingga siap buka bisnis.", icon: "GraduationCap" },
];

export const COURSES = [
  {
    title: "All In Academy", duration: "14x Pertemuan • 4 Jam/Sesi", level: "Pemula hingga Pro", price: "Rp 22.000.000",
    benefits: ["Haircut (zero to pro)", "Hair styling", "Hair perm", "Smoothing", "Hair coloring"],
  },
  {
    title: "Haircut Academy", duration: "5x Pertemuan • 4 Jam/Sesi", level: "Dasar & Lanjutan", price: "Rp 6.500.000",
    benefits: ["Teknik dasar haircut", "Pengenalan model", "Total 6 model potongan", "Praktek patung", "Praktek ke orang tiap model"],
  },
  {
    title: "Haircoloring Academy", duration: "5x Pertemuan • 4-5 Jam/Sesi", level: "Intermediate", price: "Rp 6.500.000",
    benefits: ["Teknik dasar pewarnaan", "Mengenal tekstur rambut", "Basic coloring", "Highlight, balayage", "Ombre, peek a boo", "Praktek model"],
  },
  {
    title: "Paket Usaha Pemula", duration: "Fleksibel", level: "Siap Usaha", price: "Rp 50.000.000",
    benefits: ["Sertifikat kursus academy", "Perlengkapan alat salon", "Konsultasi pasca kursus"],
  },
  {
    title: "Paket Usaha Premium", duration: "Fleksibel", level: "Siap Usaha", price: "Rp 600.000.000",
    benefits: ["Sertifikat kursus academy", "Sertifikat pemilik salon", "Peralatan salon", "Tempat salon operasional", "3 bulan pendampingan", "Produk", "Logo sendiri"],
  },
  {
    title: "Paket Usaha Luxury", duration: "Fleksibel", level: "Siap Usaha", price: "Rp 1.700.000.000",
    benefits: ["Sertifikat kursus academy", "Sertifikat pemilik", "Alat salon", "Tempat salon siap operasional", "Pelatihan", "Pendampingan 3 bulan awal", "Sistem kasir", "Produk", "Lokasi strategis"],
  },
];

export const ACADEMY_FACILITIES = [
  "Ruang kelas ber-AC dengan peralatan salon lengkap",
  "Praktek langsung dengan live model",
  "Mentor berpengalaman 10+ tahun di industri",
  "Modul cetak & video pembelajaran eksklusif",
  "Sertifikat kelulusan resmi Salon Strawberry Official",
  "Akses komunitas alumni & info lowongan kerja",
];

export const REVIEWS = [
  { name: "Amanda Putri", service: "Balayage", text: "Hasil balayage-nya beyond expectation! Warnanya blend sempurna dan rambut tetap sehat. Stylist-nya ramah banget, dijelasin detail prosesnya.", rating: 5 },
  { name: "Siti Rahma", service: "Hijab Room", text: "Akhirnya ada salon dengan ruangan khusus hijabers yang benar-benar privat. Nyaman banget, terapisnya semua wanita. Pasti balik lagi!", rating: 5 },
  { name: "Jessica Tan", service: "Nail Art", text: "Nail art-nya rapi banget, detail 3D-nya presisi. Tempatnya juga aesthetic, cocok buat foto-foto. Worth every rupiah!", rating: 5 },
  { name: "Dewi Anggraini", service: "Facial Treatment", text: "Facial glow-nya juara! Sekali treatment langsung kelihatan bedanya. Suasana spa-nya tenang dan wangi aromaterapi.", rating: 5 },
  { name: "Rina Kartika", service: "Kids Salon", text: "Anakku biasanya nangis kalau potong rambut, di sini malah betah karena kursinya lucu dan kakaknya sabar banget.", rating: 5 },
  { name: "Maya Maharani", service: "Makeup Wisuda", text: "Makeup wisudaku flawless tahan 12 jam! Natural tapi tetap glam di foto. Terima kasih Salon Strawberry Official!", rating: 5 },
];

export const COLORING_CATEGORIES = ["ALL", "BASIC COLOR", "ASH", "HIGHLIGHT", "BALAYAGE", "PEEK A BOO"];

export const GALLERY_FILTERS = ["All", "Interior"];

export const BOOKING_SERVICES = [
  "Hair Cut & Styling", "Hair Coloring / Balayage", "Body Massage & Spa", "Nail Art & Manicure",
  "Hijab Room Service", "Makeup", "Facial Treatment", "Shoe Wash",
  "Klinik Kecantikan", "Kids Salon", "Pendaftaran Academy",
];

export const MARQUEE_ITEMS = [
  "YOUR BEAUTY, OUR PASSION",
  "HAIR • BEAUTY • ACADEMY",
  "SALON STRAWBERRY OFFICIAL",
  "EXCLUSIVE BALAYAGE & BESPOKE COLORING",
  "PRIVATE HIJAB ROOM",
  "KLINIK KECANTIKAN & FACIAL GLOW",
];

export const HERO_FALLBACK = "https://images.unsplash.com/photo-1633681926035-ec1ac984418a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
